// extracted by mini-css-extract-plugin
export var header = "_9x-0";